import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey:
      import.meta.env.VITE_REMOTE_ENV === "prod"
        ? import.meta.env.VITE_INSTRUMENTATION_KEY_PROD
        : import.meta.env.VITE_INSTRUMENTATION_KEY,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
    loggingLevelConsole: 2,
  },
});
// appInsights.loadAppInsights();
export { reactPlugin, appInsights };
